import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    projects: [], // プロジェクト一覧を格納
  }
}

const state = getDefaultState()

const mutations = {
  SET_PROJECTS(state, payload) {
    state.projects = payload
  },
}

const actions = {
  // プロジェクト一覧を取得
  async getProjects({ commit }, payload) {
    const apiResult = await apiService.post(route('member.project.list'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  // プロジェクト詳細を取得
  async getRecord({ commit }, payload) {
    const apiResult = await apiService.post(route('member.project.record'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  // 林分収穫表のオプションを取得
  async getYieldTableOptions({ commit }, params) {
    try {
      const apiResult = await apiService.post(route('member.project.get_plan_field_options'), params)
      if (apiResult && apiResult.data) {
        return apiResult.data
      }
    } catch {
      return null
    }
  },
  // 森林経営計画のオプションを取得
  async getForestManagementPlanOptions({ commit }, params) {
    try {
      const apiResult = await apiService.post(route('member.project.get_forest_management_plan_options'), params)
      if (apiResult && apiResult.data) {
        return apiResult.data
      }
    } catch {
      return null
    }
  },
  // プロジェクト作成
  async create({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.create'), params)
    if (apiResult) {
      return apiResult
    }
  },
  async update({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.update'), params)
    if (apiResult) {
      return apiResult
    }
  },
  async getPlanningAreas({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.get_planning_areas'), params)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  // プロジェクト削除
  async deleteProject({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.delete'), params)
    if (apiResult) {
      return apiResult
    }
  },
  // 書類管理の取得
  async getDocuments({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.get_documents'), params)
    if (apiResult) {
      return apiResult
    }
  },
  // 登録済プロジェクトの書類管理の取得
  async getRegisteredDocuments({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.get_registered_documents'), params)
    if (apiResult) {
      return apiResult
    }
  },
  // プロジェクトの完了登録
  async completeRegisterProject({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.complete_register_project'), params)
    if (apiResult) {
      return apiResult
    }
  },
  // 施業予定があるかチェック
  async hasPlannedOperation({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.has_planned_operation'), params)
    if (apiResult && apiResult.data) {
      return apiResult.data.exists
    }
    return false
  },
  // 書類管理のエクセルを出力
  async exportDocuments({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.export_documents'), params)
    if (apiResult) {
      return apiResult
    }
  },
  // 林分収穫表のデータを取得
  async getYieldTableData({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.get_yield_table_data'), params)
    if (apiResult) {
      return apiResult
    }
  },
  async downloadYieldTable({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.download_yield_table'), params)
    if (apiResult) {
      return apiResult
    }
  },
  // 林分収穫表のデータをダウンロード
  async downloadYieldTables({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.download_yield_tables'), params)
    if (apiResult) {
      return apiResult
    }
  },
  async getForestManagementPlanByProjectId({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.get_forest_management_plan_by_project_id'), params)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async updateForestManagementPlan({ commit }, params) {
    const apiResult = await apiService.post(route('member.project.update_forest_management_plan'), params)
    if (apiResult) {
      return apiResult
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
